import { defineStore } from 'pinia'
import { ref } from 'vue'
import any from 'ramda/es/any'
import find from 'ramda/es/find'
import curry from 'ramda/es/curry'
import pipe from 'ramda/es/pipe'
import defaultTo from 'ramda/es/defaultTo'
import { persistPiniaSlice, loadPiniaSlice } from '../persist'

const predicate = curry((info, x) =>
    info.mainCategoryID === x.mainCategoryID &&
    info.subCategoryID === x.subCategoryID &&
    info.blockNum === x.blockNum
)
const exists = (blocks, info) => any(predicate(info))(blocks)
const findBlock = (blocks, info) =>
    pipe(find(predicate(info)), defaultTo({ startTime: undefined }))(blocks)

export const useBlockIntroStore = defineStore('blockIntro', () => {
    const visitedBlocks = ref([])

    const persist = () => {
        persistPiniaSlice('blockIntroStore', {
            visitedBlocks: visitedBlocks.value,
        })
    }

    const resetVisitedBlocks = () => {
        visitedBlocks.value = []
        persist()
    }

    const addVisitedBlock = (info) => {
        visitedBlocks.value.push(info)
        persist()
    }

    const blockAlreadyVisited = (info) => exists(visitedBlocks.value, info)

    const visitedBlockStartTime = (info) => findBlock(visitedBlocks.value, info).startTime

    const saved = loadPiniaSlice('blockIntroStore')
    if (saved && Array.isArray(saved.visitedBlocks)) {
        visitedBlocks.value = saved.visitedBlocks
    }

    return {
        visitedBlocks,
        resetVisitedBlocks,
        addVisitedBlock,
        blockAlreadyVisited,
        visitedBlockStartTime,
    }
})
